import { match } from 'ts-pattern';
export const getSketchingLevelHeights = (edges, shapes, getShapeHeight)=>{
    const shapesMap = {};
    const paths = [];
    const firstEdge = edges[0];
    shapesMap[firstEdge.shape.instance.entityId.toString()] = 0;
    if (firstEdge.type === 'line-start') {
        paths.push({
            startingHeight: 0,
            shape: firstEdge.shape,
            direction: 'right',
            originPoint: firstEdge.shape.start
        });
    }
    if (firstEdge.type === 'line-end') {
        paths.push({
            startingHeight: 0,
            shape: firstEdge.shape,
            direction: 'left',
            originPoint: firstEdge.shape.end
        });
    }
    if (firstEdge.type === 'rectangle-top-left') {
        paths.push({
            startingHeight: 0,
            shape: firstEdge.shape,
            direction: 'right',
            originPoint: firstEdge.shape.topLeft
        });
    }
    if (firstEdge.type === 'rectangle-top-right') {
        paths.push({
            startingHeight: 0,
            shape: firstEdge.shape,
            direction: 'left',
            originPoint: firstEdge.shape.topRight
        });
    }
    if (firstEdge.type === 'rectangle-bottom-left') {
        paths.push({
            startingHeight: 0,
            shape: firstEdge.shape,
            direction: 'left',
            originPoint: firstEdge.shape.bottomLeft
        });
    }
    if (firstEdge.type === 'rectangle-bottom-right') {
        paths.push({
            startingHeight: 0,
            shape: firstEdge.shape,
            direction: 'right',
            originPoint: firstEdge.shape.bottomRight
        });
    }
    const getNextPathStep = (shape, originPoint, direction, currentHeight, shapeHeight)=>{
        return match(shape).with({
            type: 'line'
        }, (line)=>{
            return match(direction).with('right', ()=>{
                const nextPoint = line.end.connection?.to;
                if (!nextPoint) {
                    return {
                        nextStep: undefined,
                        discoveredPaths: []
                    };
                }
                const stairsHeight = getShapeHeight(nextPoint.shape);
                const newHeight = match(nextPoint.type).with('rectangle-top-left', ()=>{
                    return currentHeight - stairsHeight;
                }).with('rectangle-top-right', ()=>{
                    return currentHeight - stairsHeight;
                }).otherwise(()=>currentHeight);
                return {
                    nextStep: {
                        shape: nextPoint.shape,
                        originPoint: nextPoint,
                        currentHeight: newHeight
                    },
                    discoveredPaths: []
                };
            }).with('left', ()=>{
                const nextPoint = line.start.connection?.from;
                if (!nextPoint) {
                    return {
                        nextStep: undefined,
                        discoveredPaths: []
                    };
                }
                const stairsHeight = getShapeHeight(nextPoint.shape);
                const newHeight = match(nextPoint.type).with('rectangle-top-left', ()=>{
                    return currentHeight - stairsHeight;
                }).with('rectangle-top-right', ()=>{
                    return currentHeight - stairsHeight;
                }).otherwise(()=>currentHeight);
                return {
                    nextStep: {
                        shape: nextPoint.shape,
                        originPoint: nextPoint,
                        currentHeight: newHeight
                    },
                    discoveredPaths: []
                };
            }).exhaustive();
        }).with({
            type: 'rectangle'
        }, (rectangle)=>{
            return match(direction).with('right', ()=>{
                if (originPoint.type === 'rectangle-top-left') {
                    const nextPoint = rectangle.bottomLeft.connection?.to;
                    const discoveredPaths = [];
                    if (rectangle.bottomRight.connection) {
                        discoveredPaths.push({
                            startingHeight: currentHeight,
                            shape: rectangle,
                            direction: 'left',
                            originPoint: rectangle.bottomRight
                        });
                    }
                    if (rectangle.topRight.connection) {
                        discoveredPaths.push({
                            startingHeight: currentHeight + shapeHeight,
                            shape: rectangle,
                            direction: 'right',
                            originPoint: rectangle.topRight
                        });
                    }
                    if (!nextPoint) {
                        return {
                            nextStep: undefined,
                            discoveredPaths
                        };
                    }
                    return {
                        nextStep: {
                            shape: nextPoint.shape,
                            originPoint: nextPoint,
                            currentHeight
                        },
                        discoveredPaths
                    };
                }
                if (originPoint.type === 'rectangle-bottom-right') {
                    const nextPoint = rectangle.topRight.connection?.to;
                    const discoveredPaths = [];
                    if (rectangle.topLeft.connection) {
                        discoveredPaths.push({
                            startingHeight: currentHeight + shapeHeight,
                            shape: rectangle,
                            direction: 'left',
                            originPoint: rectangle.topLeft
                        });
                    }
                    if (rectangle.bottomLeft.connection) {
                        discoveredPaths.push({
                            startingHeight: currentHeight,
                            shape: rectangle,
                            direction: 'right',
                            originPoint: rectangle.bottomLeft
                        });
                    }
                    if (!nextPoint) {
                        return {
                            nextStep: undefined,
                            discoveredPaths
                        };
                    }
                    return {
                        nextStep: {
                            shape: nextPoint.shape,
                            originPoint: nextPoint,
                            currentHeight: currentHeight + shapeHeight
                        },
                        discoveredPaths
                    };
                }
                if (originPoint.type === 'rectangle-top-right') {
                    const nextPoint = rectangle.topRight.connection?.to;
                    if (!nextPoint) {
                        return {
                            nextStep: undefined,
                            discoveredPaths: []
                        };
                    }
                    return {
                        nextStep: {
                            shape: nextPoint.shape,
                            originPoint: nextPoint,
                            currentHeight
                        },
                        discoveredPaths: []
                    };
                }
                if (originPoint.type === 'rectangle-bottom-left') {
                    const nextPoint = rectangle.bottomLeft.connection?.to;
                    if (!nextPoint) {
                        return {
                            nextStep: undefined,
                            discoveredPaths: []
                        };
                    }
                    return {
                        nextStep: {
                            shape: nextPoint.shape,
                            originPoint: nextPoint,
                            currentHeight
                        },
                        discoveredPaths: []
                    };
                }
                throw new Error('Invalid origin point for rectangle in the right direction!');
            }).with('left', ()=>{
                if (originPoint.type === 'rectangle-top-right') {
                    const nextPoint = rectangle.bottomRight.connection?.from;
                    const discoveredPaths = [];
                    if (rectangle.topLeft.connection) {
                        discoveredPaths.push({
                            startingHeight: currentHeight + shapeHeight,
                            shape: rectangle,
                            direction: 'left',
                            originPoint: rectangle.topLeft
                        });
                    }
                    if (rectangle.bottomLeft.connection) {
                        discoveredPaths.push({
                            startingHeight: currentHeight,
                            shape: rectangle,
                            direction: 'right',
                            originPoint: rectangle.bottomLeft
                        });
                    }
                    if (!nextPoint) {
                        return {
                            nextStep: undefined,
                            discoveredPaths
                        };
                    }
                    return {
                        nextStep: {
                            shape: nextPoint.shape,
                            originPoint: nextPoint,
                            currentHeight
                        },
                        discoveredPaths
                    };
                }
                if (originPoint.type === 'rectangle-bottom-left') {
                    const nextPoint = rectangle.topLeft.connection?.from;
                    const discoveredPaths = [];
                    if (rectangle.topRight.connection) {
                        discoveredPaths.push({
                            startingHeight: currentHeight + shapeHeight,
                            shape: rectangle,
                            direction: 'right',
                            originPoint: rectangle.topRight
                        });
                    }
                    if (rectangle.bottomRight.connection) {
                        discoveredPaths.push({
                            startingHeight: currentHeight,
                            shape: rectangle,
                            direction: 'left',
                            originPoint: rectangle.bottomRight
                        });
                    }
                    if (!nextPoint) {
                        return {
                            nextStep: undefined,
                            discoveredPaths
                        };
                    }
                    return {
                        nextStep: {
                            shape: nextPoint.shape,
                            originPoint: nextPoint,
                            currentHeight: currentHeight + shapeHeight
                        },
                        discoveredPaths
                    };
                }
                if (originPoint.type === 'rectangle-bottom-right') {
                    const nextPoint = rectangle.bottomRight.connection?.from;
                    if (!nextPoint) {
                        return {
                            nextStep: undefined,
                            discoveredPaths: []
                        };
                    }
                    return {
                        nextStep: {
                            shape: nextPoint.shape,
                            originPoint: nextPoint,
                            currentHeight
                        },
                        discoveredPaths: []
                    };
                }
                if (originPoint.type === 'rectangle-top-left') {
                    const nextPoint = rectangle.topLeft.connection?.from;
                    if (!nextPoint) {
                        return {
                            nextStep: undefined,
                            discoveredPaths: []
                        };
                    }
                    return {
                        nextStep: {
                            shape: nextPoint.shape,
                            originPoint: nextPoint,
                            currentHeight
                        },
                        discoveredPaths: []
                    };
                }
                throw new Error('Invalid origin point for rectangle in the left direction!');
            }).exhaustive();
        }).exhaustive();
    };
    const visitedPaths = new Set();
    const visitedShapes = new Set();
    let activePath = paths.pop();
    if (activePath) {
        const patKey = `${activePath.shape.instance.entityId.toString()}-${activePath.direction}-${activePath.originPoint.type}`;
        visitedPaths.add(patKey);
    }
    while(activePath){
        let nextShape = {
            shape: activePath.shape,
            originPoint: activePath.originPoint,
            currentHeight: activePath.startingHeight
        };
        const direction = activePath.direction;
        const innerVisited = new Set();
        while(nextShape){
            const instanceId = nextShape.shape.instance.entityId.toString();
            if (innerVisited.has(instanceId)) {
                return {
                    valid: false,
                    levels: {}
                };
            }
            innerVisited.add(instanceId);
            if (!visitedShapes.has(instanceId)) {
                visitedShapes.add(instanceId);
            }
            if (shapesMap[instanceId] == null) {
                shapesMap[instanceId] = nextShape.currentHeight;
            }
            const shapeHeight = getShapeHeight(nextShape.shape);
            const { nextStep, discoveredPaths } = getNextPathStep(nextShape.shape, nextShape.originPoint, direction, nextShape.currentHeight, shapeHeight);
            paths.push(...discoveredPaths);
            nextShape = nextStep;
        }
        activePath = paths.pop();
        if (activePath) {
            const patKey = `${activePath.shape.instance.entityId.toString()}-${activePath.direction}-${activePath.originPoint.type}`;
            if (visitedPaths.has(patKey)) {
                return {
                    valid: false,
                    levels: {}
                };
            }
            visitedPaths.add(patKey);
        }
    }
    const minHeight = Math.min(...Object.values(shapesMap));
    const allShapesVisited = shapes.every((shape)=>visitedShapes.has(shape.instance.entityId.toString()));
    return {
        valid: allShapesVisited,
        levels: Object.fromEntries(Object.entries(shapesMap).map(([key, value])=>[
                key,
                value - minHeight
            ]))
    };
};

//# sourceMappingURL=get-level-heights.js.map